// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (-ms-high-contrast: active){._36rXsJD1x,._2hThQk7px:hover,._65fxlTsIx.vTtAvh7Ex{background-color:highlight}._36rXsJD1x,._2hThQk7px:hover,._65fxlTsIx.vTtAvh7Ex,._36rXsJD1x *,._2hThQk7px:hover *,._65fxlTsIx.vTtAvh7Ex *{color:window !important}}._2hThQk7px{display:block;box-sizing:border-box;text-decoration:none;width:100%;color:var(--primary-text-invert)}._65fxlTsIx::before{content:'';z-index:1;position:absolute;top:0;bottom:0;left:0;width:4px;background:#006fc8}@media screen and (-ms-high-contrast: active){._65fxlTsIx::before{display:none;width:0px}}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"highlighted": "_36rXsJD1x",
	"link": "_2hThQk7px",
	"with-active-indicator": "_65fxlTsIx",
	"withActiveIndicator": "_65fxlTsIx",
	"active": "vTtAvh7Ex"
};
module.exports = exports;
